module.exports = __webpack_public_path__ + "553cc093e3734817cec14a32d7527bab.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ir.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ir.svg
// module chunks = 0